import Color from 'color';

/**
 * Returns a readable foreground color for a given background color.
 *
 * - For light backgrounds (higher luminance), it returns a darker shade of the same color.
 * - For dark backgrounds (lower luminance), it returns white.
 *
 */
const getContrastingColor = (backgroundColor: string): string => {
  const bgColor = Color(backgroundColor);
  const luminance = bgColor.luminosity();

  return luminance > 0.5 ? bgColor.darken(0.7).hex() : '#FFFFFF';
};

export default getContrastingColor;
